module.exports = __webpack_public_path__ + "static/media/ic_premium_orange.a9a4cd32.svg";